import _objectWithoutProperties from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _excluded = ["selectFormContext"];
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { ErrorResultHandler } from '@lib/domain-common';
import { Result } from '@digibricks/core';
import { AxiosApi } from '@digibricks/plugin-axios';
export var SPACE_SEARCH_API = 'SPACE_SEARCH_API';
export var SpaceObjectsApi = /*#__PURE__*/function (_AxiosApi) {
  _inherits(SpaceObjectsApi, _AxiosApi);

  var _super = _createSuper(SpaceObjectsApi);

  function SpaceObjectsApi(axiosInstance, spaceApiMapper) {
    var _this;

    _classCallCheck(this, SpaceObjectsApi);

    _this = _super.call(this, 'space', axiosInstance);
    _this.axiosInstance = axiosInstance;
    _this.spaceApiMapper = spaceApiMapper;
    return _this;
  }

  _createClass(SpaceObjectsApi, [{
    key: "search",
    value: function () {
      var _search = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(query) {
        var _ref, _selectFormContext, queryParams, url, jsonResponse, parsedResponseBody, result;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _ref = query, _selectFormContext = _ref.selectFormContext, queryParams = _objectWithoutProperties(_ref, _excluded);
                url = this.url;
                _context.next = 5;
                return this.axios.get(url, {
                  params: queryParams
                });

              case 5:
                jsonResponse = _context.sent;
                parsedResponseBody = jsonResponse.data;

                if (parsedResponseBody.data) {
                  _context.next = 9;
                  break;
                }

                return _context.abrupt("return", Result.fail(parsedResponseBody.message));

              case 9:
                result = this.spaceApiMapper.toDomain(parsedResponseBody.data);
                return _context.abrupt("return", Result.ok(result));

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](0);
                return _context.abrupt("return", ErrorResultHandler(_context.t0));

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 13]]);
      }));

      function search(_x) {
        return _search.apply(this, arguments);
      }

      return search;
    }()
  }]);

  return SpaceObjectsApi;
}(AxiosApi);